import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

export interface UpdateSnackbarData {
	onReload: () => void | Promise<void>;
}

@Component({
	selector: "app-update-snackbar",
	template: `
		<div class="update-snackbar-container">
			<mat-icon class="update-snackbar__icon" aria-hidden="true">system_update</mat-icon>
			<div class="update-snackbar__text">
				<p class="update-snackbar__title">New version ready</p>
				<p class="update-snackbar__subtitle">Tap Reload to get the latest version.</p>
			</div>
			<button type="button" class="update-snackbar__reload" (click)="onReloadClick()">Reload</button>
		</div>
	`,
	styles: [
		`
			:host {
				display: block;
				width: 100%;
			}

			.update-snackbar-container {
				display: flex;
				align-items: center;
				gap: 16px;
				padding: 4px 0;
			}

			.update-snackbar__icon {
				color: #1d4ed8;
				font-size: 28px;
				width: 28px;
				height: 28px;
				flex-shrink: 0;
			}

			.update-snackbar__text {
				flex: 1;
				min-width: 0;
			}

			.update-snackbar__title {
				margin: 0;
				font-size: 17px;
				font-weight: 600;
				line-height: 1.3;
				color: #0f172a;
			}

			.update-snackbar__subtitle {
				margin: 4px 0 0;
				font-size: 14px;
				line-height: 1.4;
				color: #334155;
			}

			.update-snackbar__reload {
				flex-shrink: 0;
				min-height: 44px;
				min-width: 96px;
				padding: 0 20px;
				border: none;
				border-radius: 8px;
				background: #1d4ed8;
				color: #ffffff;
				font-size: 15px;
				font-weight: 600;
				cursor: pointer;
			}

			.update-snackbar__reload:hover {
				background: #1e40af;
			}

			.update-snackbar__reload:focus-visible {
				outline: 2px solid #1d4ed8;
				outline-offset: 2px;
			}
		`,
	],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIconModule, MatButtonModule],
})
export class UpdateSnackbarComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<UpdateSnackbarComponent>,
		@Inject(MAT_SNACK_BAR_DATA) private readonly data: UpdateSnackbarData,
	) {}

	async onReloadClick(): Promise<void> {
		await this.data.onReload();
		this.snackBarRef.dismiss();
	}
}
